import React from "react"; import { Collapse } from "react-bootstrap"; import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

const Filter = ({
  setOpenMenu,
  openMenu,
  onSubmit,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  searchTerm,
  phoneVerified,
  setPhoneVerified,
  emailVerified,
  setEmailVerified,
  resetButtonDisabled = true,
  onResetButtonClick = () => {},
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="filter cm-content-box box-primary">
          <div
            className="content-title SlideToolHeader"
            onClick={() => setOpenMenu(!openMenu)}
          >
            <div className="cpa">
              <i className="fa-sharp fa-solid fa-filter me-2" />
              Filter
            </div>
            <div className="tools">
              <Link
                to={"#"}
                className={`handle ${openMenu ? "expand" : "collpase"}`}
              >
                <i className="fal fa-angle-down" />
              </Link>
            </div>
          </div>
          <Collapse in={openMenu}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="mb-3 col-lg-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name , email or phone number ..."
                      required=""
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="mb-3 col-lg-2 col-md-2">
                    <select
                      className="form-select"
                      value={statusFilter}
                      onChange={e => setStatusFilter(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="unblocked">Unblocked</option>
                      <option value="blocked">Blocked</option>
                    </select>
                  </div>
                  <div className="mb-3 col-lg-4 col-md-4 d-flex align-items-center gap-3">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="phoneVerifiedCheckbox"
                        checked={phoneVerified}
                        onChange={e => setPhoneVerified(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="phoneVerifiedCheckbox">
                        Phone Verified
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="emailVerifiedCheckbox"
                        checked={emailVerified}
                        onChange={e => setEmailVerified(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="emailVerifiedCheckbox">
                        Email Verified
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 align-self-end mb-3 d-flex gap-2">
                    <button
                      onClick={onSubmit}
                      className="btn btn-sm btn-primary rounded-sm flex-fill"
                      title="Click here to Search"
                      type="button"
                    >
                      <i className="fa fa-search me-1" />
                      Search
                    </button>
                    <button
                      className={`btn btn-sm flex-fill reset-filter-btn ${!resetButtonDisabled ? 'enabled' : 'disabled'}`}
                      disabled={resetButtonDisabled}
                      onClick={onResetButtonClick}
                      type="button"
                      title="Reset Filters"
                    >
                      <i className="fa fa-times me-1" /> Reset Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default Filter;
